/**
 * Rentiamo Dates — widget date noleggio (sostituto di IzyRent).
 *
 * Modello d'uso (come IzyRent con durationVariants):
 *  - il cliente sceglie la DATA EVENTO e la DATA RITIRO sul calendario;
 *  - il ritiro è libero DENTRO la fascia durata selezionata come variante
 *    (es. "4-7 giorni": ritiro dal 4° al 7° giorno incluso — la durata conta
 *    entrambi gli estremi: 12→18 agosto = 7 giorni);
 *  - piè di calendario con "Durata: N giorni" + Cancella/Salva;
 *  - sotto il widget: "Data inizio evento" / "Data fine evento".
 *
 * Principi di robustezza (le tre cause dei bug IzyRent, da non ripetere):
 *  1. Nessuna "scadenza" delle righe carrello: le proprietà scritte restano.
 *  2. Nessuna intercettazione asincrona dell'add-to-cart: le proprietà sono
 *     hidden input dentro il form standard; l'unico intervento sul submit è
 *     una validazione sincrona con errore VISIBILE se mancano le date.
 *  3. Lo stato (date scelte) sopravvive ai re-render della sezione prodotto
 *     (cambio variante/quickview): un MutationObserver re-inizializza il
 *     widget e ripristina le date già selezionate.
 *
 * Dipendenze: rentiamo-flatpickr.min.js (flatpickr 4.6.13 + locale it).
 */
(function () {
  'use strict';

  if (window.RentiamoDates) return; // doppio caricamento
  var MONTHS_IT = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
    'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];
  var MONTHS_EN = ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'];
  // Etichette localizzabili: default IT; su pagine non-IT init() passa a L_EN (config.locale dal snippet)
  var L = {
    months: MONTHS_IT, dateJoin: ' al ', cancel: 'Cancella', save: 'Salva',
    selEnd: 'Seleziona anche la data di ritiro', durata: 'Durata: ', giorni: ' giorni',
    ritiroDal: 'Ritiro: dal ', ritiroAl: ' al ', selEvento: 'Seleziona la data dell’evento',
    placeholder: 'Prenota le date', errDates: 'Seleziona le date per continuare'
  };
  var L_EN = {
    months: MONTHS_EN, dateJoin: ' to ', cancel: 'Clear', save: 'Save',
    selEnd: 'Please also select the end date', durata: 'Duration: ', giorni: ' days',
    ritiroDal: 'Pick-up: from ', ritiroAl: ' to ', selEvento: 'Select your event date',
    placeholder: 'Select your dates', errDates: 'Select your dates to continue'
  };
  var LS_KEY = 'rentiamo:lastDates';

  // Stato per prodotto: sopravvive ai re-render della sezione.
  var dateByProduct = {};   // productId -> { from: 'YYYY-MM-DD', to: 'YYYY-MM-DD' }
  var widgetByForm = {};    // formId -> root element (l'ultimo inizializzato)

  // ── Utilità date ──────────────────────────────────────────────────────────
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function toISO(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function fromISO(s) {
    var p = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s || '');
    return p ? new Date(+p[1], +p[2] - 1, +p[3]) : null;
  }
  function formatIt(d) { return d.getDate() + ' ' + L.months[d.getMonth()] + ' ' + d.getFullYear(); }
  function addDays(d, n) { var c = new Date(d); c.setDate(c.getDate() + n); return c; }
  function startOfDay(d) { return new Date(d.getFullYear(), d.getMonth(), d.getDate()); }
  // giorni INCLUSIVI: 12→18 = 7
  function diffDaysInc(a, b) { return Math.round((startOfDay(b) - startOfDay(a)) / 86400000) + 1; }

  // "1-3 giorni" -> {min:1,max:3}; "oltre 15 giorni" -> {min:16,max:null}
  function parseFascia(text) {
    var v = String(text || '').toLowerCase();
    var m = /(\d+)\s*[-–]\s*(\d+)/.exec(v);
    if (m) return { min: +m[1], max: +m[2] };
    var o = /(?:oltre|over|more than)\s*(\d+)/.exec(v);
    if (o) return { min: +o[1] + 1, max: null };
    var p = /(\d+)\s*\+/.exec(v);
    if (p) return { min: +p[1] + 1, max: null };
    return null;
  }
  function fasciaContains(f, giorni) {
    return !!f && giorni >= f.min && (f.max === null || giorni <= f.max);
  }

  // Cerca, vicino al widget, il radio della fascia durata che contiene la
  // durata richiesta (es. 6 giorni → radio "4-7 giorni") — per riproporre su
  // un altro prodotto le stesse date scelte prima.
  function findFasciaRadio(root, giorni) {
    var scope = root.closest('.shopify-section, quick-view, dialog') || document;
    var radios = scope.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (fasciaContains(parseFascia(radios[i].value), giorni)) return radios[i];
    }
    return null;
  }

  // ── Accesso a form e config ───────────────────────────────────────────────
  function getConfig(root) {
    try {
      return JSON.parse(root.querySelector('[data-rentiamo-config]').textContent);
    } catch (e) { return null; }
  }
  function getForm(root) {
    var id = root.getAttribute('data-form-id');
    return id ? document.getElementById(id) : null;
  }
  function currentFascia(root) {
    var cfg = root._rdConfig;
    var form = getForm(root);
    if (!cfg || !cfg.variants || !cfg.variants.length) return null;
    var vid = null;
    if (form) {
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) vid = String(idInput.value);
    }
    var variant = null;
    for (var i = 0; i < cfg.variants.length; i++) {
      if (String(cfg.variants[i].id) === vid) { variant = cfg.variants[i]; break; }
    }
    if (!variant) variant = cfg.variants[0];
    return parseFascia(variant.durata);
  }

  // Finestra di ritiro consentita per la fascia corrente, dato l'inizio.
  function endWindow(root, start) {
    var f = currentFascia(root) || { min: 1, max: 1 };
    var globalMax = root._rdGlobalMax || addDays(startOfDay(new Date()), 365);
    var minEnd = addDays(start, f.min - 1);
    var maxEnd = f.max ? addDays(start, f.max - 1) : globalMax;
    if (maxEnd > globalMax) maxEnd = globalMax;
    return { minEnd: minEnd, maxEnd: maxEnd, fascia: f };
  }
  function clampEnd(root, start, end) {
    var w = endWindow(root, start);
    if (end < w.minEnd) return w.minEnd;
    if (end > w.maxEnd) return w.maxEnd;
    return end;
  }

  // ── Proprietà di riga nel form ────────────────────────────────────────────
  function upsertProp(form, name, value) {
    var sel = 'input[type="hidden"][name="properties[' + name + ']"]';
    var el = form.querySelector(sel);
    if (value === null) { if (el) el.remove(); return; }
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = 'properties[' + name + ']';
      el.setAttribute('data-rentiamo-prop', '1');
      form.appendChild(el);
    }
    el.value = value;
  }
  function clearProps(form) {
    ['Date', 'Quantity', '_data_inizio', '_data_fine'].forEach(function (n) { upsertProp(form, n, null); });
  }

  function currentQty(root) {
    var q = root.querySelector('.izyMultiInput');
    var v = q ? parseInt(q.value, 10) : 1;
    return (isNaN(v) || v < 1) ? 1 : v;
  }

  // Scrive quantità nel campo nativo del tema (name="quantity") così il
  // submit standard la porta con sé.
  function syncQty(root) {
    var form = getForm(root);
    if (!form) return;
    var v = currentQty(root);
    // NB: mai usare form.id — l'input name="id" della variante lo mette in ombra
    var formId = form.getAttribute('id');
    var native = form.querySelector('input[name="quantity"]') ||
      document.querySelector('input[name="quantity"][form="' + formId + '"]');
    if (native && String(native.value) !== String(v)) {
      native.value = v;
      native.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (dateByProduct[root._rdProductId]) {
      upsertProp(form, 'Quantity', String(v));
    }
  }

  // ── Applicazione delle date ───────────────────────────────────────────────
  function applyDates(root, fromIso, toIso, opts) {
    opts = opts || {};
    var form = getForm(root);
    var start = fromISO(fromIso);
    var end = fromISO(toIso);
    if (!form || !start || !end) return;

    upsertProp(form, 'Date', formatIt(start) + L.dateJoin + formatIt(end));
    upsertProp(form, '_data_inizio', toISO(start));
    upsertProp(form, '_data_fine', toISO(end));
    upsertProp(form, 'Quantity', String(currentQty(root)));

    var recap = root.querySelector('.rentiamo-dates__recap');
    if (recap) {
      var s = recap.querySelector('.rentiamo-dates__start');
      var e = recap.querySelector('.rentiamo-dates__end');
      if (s) s.textContent = formatIt(start);
      if (e) e.textContent = formatIt(end);
      recap.hidden = false;
    }
    hideError(root);

    dateByProduct[root._rdProductId] = { from: toISO(start), to: toISO(end) };
    if (!opts.silent) {
      try { localStorage.setItem(LS_KEY, JSON.stringify({ from: toISO(start), to: toISO(end) })); } catch (e2) { /* storage negato */ }
    }
    updateFooter(root);
    updateSteps(root);
  }

  function clearDates(root) {
    var form = getForm(root);
    delete dateByProduct[root._rdProductId];
    if (form) clearProps(form);
    var recap = root.querySelector('.rentiamo-dates__recap');
    if (recap) recap.hidden = true;
    updateFooter(root);
    updateSteps(root);
  }

  // Percorso guidato: passo 1 date → passo 2 quantità.
  // La quantità resta bloccata (attenuata) finché le date non sono scelte;
  // a date scelte il "1" diventa una spunta e la quantità si sblocca.
  function updateSteps(root) {
    var done = !!dateByProduct[root._rdProductId];
    var stepDates = root.querySelector('[data-step="dates"]');
    var stepQty = root.querySelector('[data-step="qty"]');
    if (stepDates) {
      stepDates.classList.toggle('rentiamo-dates__step--done', done);
      var num = stepDates.querySelector('.rentiamo-dates__step-num');
      if (num) num.textContent = done ? '✓' : '1';
    }
    if (stepQty) {
      stepQty.classList.toggle('rentiamo-dates__step--locked', !done);
      var ctrls = stepQty.querySelectorAll('.izyMultiInput, .subizy, .addizy');
      for (var i = 0; i < ctrls.length; i++) ctrls[i].disabled = !done;
    }
  }

  function showError(root, msg) {
    var err = root.querySelector('.rentiamo-dates__error');
    if (err) {
      if (msg) err.textContent = msg;
      err.hidden = false;
      try { err.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) { err.scrollIntoView(); }
    }
    var field = root.querySelector('.rentiamo-dates__field');
    if (field) field.classList.add('rentiamo-dates__field--error');
  }
  function hideError(root) {
    var err = root.querySelector('.rentiamo-dates__error');
    if (err) err.hidden = true;
    var field = root.querySelector('.rentiamo-dates__field');
    if (field) field.classList.remove('rentiamo-dates__field--error');
  }

  // ── Piè di calendario: "Durata: N giorni" + Cancella/Salva ────────────────
  function buildFooter(root, fp) {
    var foot = document.createElement('div');
    foot.className = 'rentiamo-cal-footer';
    foot.innerHTML =
      '<button type="button" class="rentiamo-cal-cancel">' + L.cancel + '</button>' +
      '<span class="rentiamo-cal-durata"></span>' +
      '<button type="button" class="rentiamo-cal-save">' + L.save + '</button>';
    fp.calendarContainer.appendChild(foot);

    foot.querySelector('.rentiamo-cal-cancel').addEventListener('click', function () {
      fp.clear();
      clearDates(root);
      try { localStorage.removeItem(LS_KEY); } catch (e) { /* storage negato */ }
      fp.set('minDate', root._rdGlobalMin);
      fp.set('maxDate', root._rdGlobalMax);
    });
    foot.querySelector('.rentiamo-cal-save').addEventListener('click', function () {
      if (fp.selectedDates.length === 2) {
        fp.close();
      } else {
        updateFooter(root, L.selEnd);
      }
    });
    root._rdFooter = foot;
    updateFooter(root);
  }

  function updateFooter(root, hint) {
    var foot = root._rdFooter;
    if (!foot) return;
    var el = foot.querySelector('.rentiamo-cal-durata');
    var fp = root._rdPicker;
    if (hint) { el.textContent = hint; return; }
    if (fp && fp.selectedDates.length === 2) {
      el.textContent = L.durata + diffDaysInc(fp.selectedDates[0], fp.selectedDates[1]) + L.giorni;
    } else if (fp && fp.selectedDates.length === 1) {
      var w = endWindow(root, fp.selectedDates[0]);
      el.textContent = L.ritiroDal + formatIt(w.minEnd) + L.ritiroAl + formatIt(w.maxEnd);
    } else {
      el.textContent = L.selEvento;
    }
  }

  // ── Stepper quantità (default; sui prodotti "multiplo-N" comanda lo script
  //    del tema, che marca i bottoni con data-mpack-bound) ──────────────────
  function bindQty(root) {
    var input = root.querySelector('.izyMultiInput');
    var plus = root.querySelector('.addizy');
    var minus = root.querySelector('.subizy');
    if (!input) return;

    function step(delta) {
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      v = Math.max(1, v + delta);
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (plus) plus.addEventListener('click', function (e) {
      if (plus.dataset.mpackBound) return; // gestito dallo script multipli del tema
      e.preventDefault(); step(1);
    });
    if (minus) minus.addEventListener('click', function (e) {
      if (minus.dataset.mpackBound) return;
      e.preventDefault(); step(-1);
    });
    root.addEventListener('input', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('izyMultiInput')) syncQty(root);
    });
    root.addEventListener('change', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('izyMultiInput')) syncQty(root);
    });
  }

  // Nasconde il selettore quantità nativo del tema (con IzyRent era già
  // nascosto; lo garantiamo anche senza IzyRent).
  function hideNativeQty(root) {
    var form = getForm(root);
    if (!form) return;
    var native = form.querySelector('input[name="quantity"]') ||
      document.querySelector('input[name="quantity"][form="' + form.getAttribute('id') + '"]');
    if (!native) return;
    var comp = native.closest('quantity-input');
    if (comp) comp.style.display = 'none';
  }

  // ── Inizializzazione di un widget ─────────────────────────────────────────
  function init(root) {
    if (root.dataset.rdInit) return;
    var cfg = getConfig(root);
    if (cfg && cfg.locale && cfg.locale !== 'it') L = L_EN;
    if (!cfg || !window.flatpickr) return;
    root.dataset.rdInit = '1';
    root._rdConfig = cfg;
    root._rdProductId = String(cfg.productId);
    widgetByForm[cfg.formId] = root;

    var input = root.querySelector('.rentiamo-dates__input');
    if (!input) return;

    var minLead = parseInt(root.getAttribute('data-min-lead-days') || '1', 10);
    var maxDays = parseInt(root.getAttribute('data-max-days') || '365', 10);
    var today = startOfDay(new Date());
    var globalMin = addDays(today, minLead);
    root._rdGlobalMin = globalMin;
    root._rdGlobalMax = addDays(today, maxDays);

    var locale = (window.flatpickr.l10ns && window.flatpickr.l10ns.it) || 'default';

    root._rdPicker = window.flatpickr(input, {
      mode: 'range',
      locale: locale,
      minDate: globalMin,
      maxDate: root._rdGlobalMax,
      dateFormat: 'Y-m-d',
      altInput: true,
      altFormat: 'j F Y',
      altInputClass: 'rentiamo-dates__input rentiamo-dates__input--alt',
      disableMobile: true,
      closeOnSelect: false,
      onReady: function (dates, str, fp) { buildFooter(root, fp); },
      onChange: function (dates, str, fp) {
        if (dates.length === 1) {
          // Inizio scelto: da qui si va SOLO in avanti, dentro la finestra
          // di ritiro della fascia (niente date precedenti all'evento).
          fp.set('minDate', dates[0]);
          fp.set('maxDate', endWindow(root, dates[0]).maxEnd);
          updateFooter(root);
        } else if (dates.length === 2) {
          var start = dates[0];
          var end = clampEnd(root, start, dates[1]);
          if (toISO(end) !== toISO(dates[1])) {
            // ritiro fuori fascia: aggiusta alla data valida più vicina
            fp.setDate([start, end], false);
          }
          applyDates(root, toISO(start), toISO(end));
          // riapre la navigazione completa per un'eventuale nuova selezione
          fp.set('minDate', root._rdGlobalMin);
          fp.set('maxDate', root._rdGlobalMax);
        } else {
          updateFooter(root);
        }
      },
      onClose: function (dates, str, fp) {
        if (fp.selectedDates.length < 2) {
          // selezione incompleta: ripristina l'ultima valida, o azzera
          var st = dateByProduct[root._rdProductId];
          if (st) {
            fp.setDate([fromISO(st.from), fromISO(st.to)], false);
          } else {
            fp.clear();
          }
          fp.set('minDate', root._rdGlobalMin);
          fp.set('maxDate', root._rdGlobalMax);
          updateFooter(root);
        }
      },
    });
    if (root._rdPicker.altInput) root._rdPicker.altInput.placeholder = L.placeholder;

    bindQty(root);
    hideNativeQty(root);

    // Ripristino date: prima lo stato di sessione (re-render), poi le ultime
    // date usate su un altro prodotto/pagina (le date seguono il cliente).
    var saved = dateByProduct[root._rdProductId];
    var fromSession = !!saved;
    if (!saved) {
      try { saved = JSON.parse(localStorage.getItem(LS_KEY) || 'null'); } catch (e) { saved = null; }
    }
    if (saved && saved.from && saved.to) {
      var from = fromISO(saved.from);
      var to = fromISO(saved.to);
      if (from && to && from >= globalMin && to >= from) {
        var durata = diffDaysInc(from, to);
        if (fromSession || fasciaContains(currentFascia(root), durata)) {
          // stessa fascia (o ripristino post re-render): date intatte
          var to2 = clampEnd(root, from, to);
          root._rdPicker.setDate([from, to2], false);
          applyDates(root, toISO(from), toISO(to2), { silent: true });
        } else {
          // fascia diversa da quella di default di QUESTO prodotto:
          // seleziona da solo la fascia giusta (come farebbe il cliente),
          // così l'intervallo scelto resta identico su ogni prodotto.
          var radio = findFasciaRadio(root, durata);
          if (radio && !radio.checked) {
            radio.click();
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
          // Applica comunque tra un attimo: se il tema ha ri-renderizzato la
          // sezione ci pensa la nuova init; altrimenti applichiamo qui, con la
          // fascia ormai aggiornata.
          setTimeout(function () {
            if (!document.body.contains(root)) return;          // sezione sostituita
            if (dateByProduct[root._rdProductId]) return;       // già applicato
            var toFix = clampEnd(root, from, to);
            if (root._rdPicker) root._rdPicker.setDate([from, toFix], false);
            applyDates(root, toISO(from), toISO(toFix), { silent: true });
          }, 400);
        }
      }
    }

    syncQty(root);
    updateSteps(root);
  }

  function initAll(scope) {
    var list = (scope || document).querySelectorAll('[data-rentiamo-dates]:not([data-rd-init])');
    for (var i = 0; i < list.length; i++) init(list[i]);
  }

  // ── Listener globali (una sola volta) ─────────────────────────────────────

  // Validazione sincrona sul submit: se mancano le date, blocca e MOSTRA l'errore.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute) return;
    // NB: non usare form.id — l'input name="id" della variante lo mette in ombra
    var formId = form.getAttribute('id');
    if (!formId || !widgetByForm[formId]) return;
    var root = widgetByForm[formId];
    if (!document.body.contains(root)) { delete widgetByForm[formId]; return; }

    var st = dateByProduct[root._rdProductId];
    if (!st || !st.from || !st.to) {
      e.preventDefault();
      e.stopPropagation();
      showError(root, L.errDates);
      return;
    }
    // Date presenti: riallinea proprietà e quantità un'ultima volta.
    applyDates(root, st.from, st.to, { silent: true });
    syncQty(root);
  }, true);

  // Cambio variante (fascia durata): riadatta il ritiro alla nuova finestra.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.name) return;
    if (t.name === 'id' || /^(Durata|options\[)/i.test(t.name)) {
      // il tema aggiorna input[name=id] in modo asincrono: ricalcola dopo un attimo
      setTimeout(function () {
        for (var fid in widgetByForm) {
          var root = widgetByForm[fid];
          if (!document.body.contains(root)) continue;
          var st = dateByProduct[root._rdProductId];
          if (!st) continue;
          var from = fromISO(st.from);
          var to = clampEnd(root, from, fromISO(st.to));
          if (root._rdPicker) root._rdPicker.setDate([from, to], false);
          applyDates(root, toISO(from), toISO(to), { silent: true });
        }
      }, 50);
    }
  }, true);

  // Re-render della sezione (cambio variante / quickview): re-inizializza.
  var mo = new MutationObserver(function (mutations) {
    var needsInit = false;
    for (var i = 0; i < mutations.length && !needsInit; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && (n.hasAttribute && n.hasAttribute('data-rentiamo-dates') || n.querySelector && n.querySelector('[data-rentiamo-dates]'))) {
          needsInit = true; break;
        }
      }
    }
    if (needsInit) initAll();
  });

  function start() {
    initAll();
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.RentiamoDates = { initAll: initAll, _state: dateByProduct };
})();
